import { capitalize } from '@sonar-software/sonar-ts-lib';
import classNames from 'classnames';
import { SonarText } from '@ui/text';
import { When } from 'react-if';

import React, { PropsWithChildren } from 'react';

export type FilterContainerDisplay = 'form' | 'inline' | 'inline-reverse';

export interface FilterContainerProps {
	className?: string;
	display?: FilterContainerDisplay;
	label?: string;
}

export const FilterContainer: React.FC<PropsWithChildren<FilterContainerProps>> = ({
	children,
	className,
	display = 'form',
	label
}) =>
	<div className={ classNames('filter-container', display, className) }>
		<When condition={ Boolean(label) }>{ <SonarText>{ capitalize(label) }</SonarText> }</When>
		{ children }
	</div>;
